import { monitorRequest } from '../../monitoring/request';
import { IHttpClient } from '@wix/http-client';
import {
  ITemplateRepository,
  LoadTemplatesParams,
  SearchTemplatesParams,
} from './proto/ITemplateRepository';
import { queryTemplates } from '@wix/ambassador-funnel-templates-gallery-v2-template/http';

import { mapAmbassadorTemplate } from '../entities/template';

export class HttpTemplateRepository implements ITemplateRepository {
  constructor(private httpClient: IHttpClient) {}

  async loadTemplates(params: LoadTemplatesParams) {
    const { categoryId, language, limit, offset } = params;

    const response = await monitorRequest(
      offset > 0 ? 'paginate-templates' : 'load-templates',
      () =>
        this.httpClient.request(
          queryTemplates({
            space: 'studio',
            categoryIds: [categoryId],
            language,
            limit,
            offset,
          }),
        ),
    );

    const templates = (response.data.templates || []).map(
      mapAmbassadorTemplate,
    );

    return {
      templates,
      total: response.data.pagingMetadata?.total || 0,
      offset,
    };
  }

  async searchTemplates({
    language,
    limit,
    offset,
    query,
  }: SearchTemplatesParams) {
    const response = await monitorRequest(
      offset > 0 ? 'paginate-templates' : 'search-templates',
      () =>
        this.httpClient.request(
          queryTemplates({
            space: 'studio',
            search: query.slice(0, 100), // validation does not allow more than 100 chars
            language,
            limit,
            offset,
          }),
        ),
    );

    return {
      templates: (response.data.templates || []).map(mapAmbassadorTemplate),
      total: response.data.pagingMetadata?.total || 0,
      offset,
    };
  }
}
